export default "__VITE_ASSET__F2LMfrTu__"